import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import {MenuItem} from '@mui/material'
import {Link} from 'react-router-dom'
import {useEffect, useState} from 'react'

import './TopNavbar.scss'
import Profile from "./Profile";
import apiClient from "./axios/axiosInterceptor";

function TopNavbar({onSuccessfulLogout, loggedInUser}) {
    const [permissions, setPermissions] = useState([]);
    const [godPermission, setGodPermission] = useState(false);

    useEffect(() => {
        const fetchPermissions = async () => {
            if (loggedInUser.RoleName === 'God') {
                setGodPermission(true);
            } else {
                const url = `/tenants/${loggedInUser.TenantId}/roles/${loggedInUser.RoleId}/permissions`;
                const response = await apiClient.get(url);
                setPermissions(response.data.list);
            }
        };

        fetchPermissions();
    }, []);

    return (
        <div className="navbar">
            <Menu1/>
            <Menu2/>
            {godPermission && (
                <Menu3/>
            )}
            <Profile onSuccessfulLogout={() => onSuccessfulLogout()} loggedInUser={loggedInUser}/>
        </div>
    )
}

function Menu1() {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const closeMenu = () => {
        setAnchorEl(null);
    };

    return (
        <div id="menu1">
            <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleMenu}>Home</Button>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={closeMenu}>
                <MenuItem onClick={closeMenu}>
                    <Link to="/">Home</Link>
                </MenuItem>
            </Menu>
        </div>
    )
}

function Menu2() {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const closeMenu = () => {
        setAnchorEl(null);
    };

    return (
        <div id="menu2">
            <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleMenu}>Features</Button>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={closeMenu}>
                <MenuItem onClick={closeMenu}>
                    <Link to="/users">Users</Link>
                </MenuItem>
                <MenuItem onClick={closeMenu}>
                    <Link to="/roles">Roles</Link>
                </MenuItem>
                <MenuItem onClick={closeMenu}>
                    <Link to="/projects">Projects</Link>
                </MenuItem>
            </Menu>
        </div>
    )
}

function Menu3() {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const closeMenu = () => {
        setAnchorEl(null);
    };

    return (
        <div id="menu3">
            <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleMenu}>System Administration</Button>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={closeMenu}>
                <MenuItem onClick={closeMenu}>
                    <Link to="/languages">Languages</Link>
                </MenuItem>

                <MenuItem onClick={closeMenu}>
                    <Link to="/languageLocales">Language Locales</Link>
                </MenuItem>

                <MenuItem onClick={closeMenu}>
                    <Link to="/backgroundFiles">Background Files</Link>
                </MenuItem>

                <MenuItem onClick={closeMenu}>
                    <Link to="/sttServiceProviders">STT Service Providers</Link>
                </MenuItem>

                <MenuItem onClick={closeMenu}>
                    <Link to="/speechModels">Speech Models</Link>
                </MenuItem>

                <MenuItem onClick={closeMenu}>
                    <Link to="/ttsServiceProviders">TTS Service Providers</Link>
                </MenuItem>

                <MenuItem onClick={closeMenu}>
                    <Link to="/voices">Voices</Link>
                </MenuItem>
            </Menu>
        </div>
    )
}

export default TopNavbar;
